const getPhoneDigits = (value) => String(value || '').replace(/\D/g, '');

const normalizeRegistrationPhone = (value) => {
  const digits = getPhoneDigits(value);
  const nationalDigits = digits.startsWith('1')
    ? digits.slice(1)
    : digits;

  return nationalDigits.slice(0, 10);
};

const formatRegistrationPhone = (value) => {
  const digits = normalizeRegistrationPhone(value);
  if (!digits) return '';

  const areaCode = digits.slice(0, 3);
  const prefix = digits.slice(3, 6);
  const lineNumber = digits.slice(6, 10);
  let formatted = `+1 (${areaCode}`;

  if (areaCode.length === 3) formatted += ')';
  if (prefix) formatted += ` ${prefix}`;
  if (lineNumber) formatted += `-${lineNumber}`;

  return formatted;
};

const isValidRegistrationPhone = (value) => normalizeRegistrationPhone(value).length === 10;

module.exports = {
  formatRegistrationPhone,
  isValidRegistrationPhone,
  normalizeRegistrationPhone,
};
